<template>
  <div class="comment-archive-1">
    <m-comment-form1 class="comment-archive-1-form" :commentable_id="commentable_id"
                     :commentable_type="commentable_type"/>
    <m-comments-wrapper :commentType="commentable_type" :item_id="commentable_id">
      <template v-slot="{comments,pagination,changePageFunction}">


        <div class="comment-archive-1-body">
          <div class="comment-archive-1-comments">
            <component :class="commentCardClass" v-for="comment in comments" :comment="comment" :is="commentCard"/>
          </div>

          <div class="comment-archive-1-pagination">
            <m-paginate1 :meta="pagination" :on-change-page="changePageFunction"/>
          </div>

        </div>


      </template>
    </m-comments-wrapper>
  </div>
</template>

<script>
import {commentProps} from "../CommentProps";
import mCommentForm1 from "../../Comment/Form/CommentForm1.vue";
import mCommentsWrapper from "../../Wrappers/CommentsWrapper.vue";
import {Card} from "../Card/Card";
import mPaginate1 from "../../Pagination/Paginate1.vue";

export default {
  name: "Comments1",
  components: {mPaginate1, mCommentForm1, mCommentsWrapper, ...Card},
  props: {
    ...commentProps,
  }
}
</script>

<style scoped>

</style>